// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "scripts/" + {"141":"6815f3bb31455a13eb17","235":"18a49c08eb2b5e25dab3","360":"1d5a44ac86f75ece05b9","928":"a3d0f5118c2732c31f67","962":"c6a6a3c4dce452e6db88"}[chunkId] + ".chunk.js";
};